import React from 'react';
import {
  Container,
  LoginBox,
  Title,
  ResetLink,
  ResetLinkContainer,
  SmallText,
  ContentWrapper,
  ExpertFooterContentBox,
} from '../SSOLoginPage.styles';
import AuthLayout from '../../../AuthLayout/Old/AuthLayout';
import environment from '../../../../environment';

const SSOExpertLoginPage = ({ children }) => {
  const { expertEmail } = environment.expertContext;

  return (
    <AuthLayout>
      <Container>
        <LoginBox>
          <ContentWrapper>
            <Title>Sign-in</Title>
            <SmallText>Sign in to your account</SmallText>
            {children}
            <ResetLinkContainer>
              <ResetLink to="/password/reset">Forgot your password?</ResetLink>
            </ResetLinkContainer>
          </ContentWrapper>
        </LoginBox>
        <ExpertFooterContentBox>
          Having Trouble Signing in? Please contact:
          <div>
            <a href={`mailto:${expertEmail}`}>{expertEmail}</a>
          </div>
        </ExpertFooterContentBox>
      </Container>
    </AuthLayout>
  );
};

export default SSOExpertLoginPage;
